import { useRef } from 'react';

import type {
	ExtensionConfiguration,
	ToolbarExtensionConfiguration,
} from '@atlaskit/editor-plugin-selection-extension';
import AddIcon from '@atlaskit/icon/core/add';
import NoteIcon from '@atlaskit/icon/core/note';

import { useFullPageEditorApi } from '@confluence/full-page-editor-store';

export const useNoteSelectionExtension = () => {
	const [{ fullPageEditorPresetAPI }] = useFullPageEditorApi();
	const editorApiRef = useRef(fullPageEditorPresetAPI);
	editorApiRef.current = fullPageEditorPresetAPI;

	const toolbarConfiguration: ToolbarExtensionConfiguration = {
		getToolbarItem: () => ({
			icon: NoteIcon,
			tooltip: 'Create a note',
			onClick: () => alert('Create note clicked'),
		}),
		getMenuItems: () => {
			// const { text, coords } =
			//     editorApiRef.current?.selectionExtension?.actions.getSelectionText();

			return [
				{
					label: 'Lorem ipsum',
					icon: NoteIcon,
					onClick: () => alert('Lorem ipsum clicked'),
				},
				{
					label: 'Consectetur adipiscing elit',
					icon: NoteIcon,
					onClick: () => alert('Consectetur adipiscing elit clicked'),
				},
				{
					label: 'Sed do eiusmod',
					icon: NoteIcon,
					onClick: () => alert('Sed do eiusmod clicked'),
				},
				{
					label: 'Create a note',
					icon: AddIcon,
					onClick: () => alert('Create note clicked'),
				},
			];
		},
	};

	const noteSelectionExtension: ExtensionConfiguration = {
		key: 'note-selection-extension',
		source: 'first-party',
		primaryToolbar: toolbarConfiguration,
		inlineToolbar: toolbarConfiguration,
	};

	const toolbarItemOnlyExtension: ExtensionConfiguration = {
		key: 'toolbar-item-only-extension',
		source: 'first-party',
		inlineToolbar: {
			getToolbarItem: () => ({
				icon: NoteIcon,
				tooltip: 'Toolbar item only',
				onClick: () => alert('Toolbar item only clicked'),
			}),
		},
		primaryToolbar: {
			getToolbarItem: () => ({
				icon: NoteIcon,
				tooltip: 'Toolbar item only',
				onClick: () => alert('Toolbar item only clicked'),
			}),
		},
	};

	return {
		extensionList: [noteSelectionExtension, toolbarItemOnlyExtension],
	};
};
